module.exports = __webpack_public_path__ + "static/media/Project-korea.efcb0682.svg";